import styled, { css } from "styled-components"

export default {
    "Header": styled.header`
        width: 100%;
        height: 96px;
        display: flex;
        align-items: center;

        ${({ $login }) => $login
            ? css`
                justify-content: space-between;
                padding: 0 65px;
            `
            : css`
                justify-content: center;
            `
        }
    `,
    "LogoImg": styled.img`
        width: 117px;
    `,

    "ProfileDiv": styled.div`
        width: fit-content;
        display: flex;
        flex-direction: column;
        align-items: end;

        & > p {
            color: ${({ theme }) => theme.color.grey4};
            ${({ theme }) => theme.font.small};
        }

        & > h2 {
            ${({ theme }) => theme.font.medium_bold};
        }
    `

    // "HorDiv": styled.div`
    //     display: flex;
    //     flex-direction: row;
    //     align-items: center;
    // `,
    // "TabNameLabel": styled.h2`
    //     ${({ theme }) => theme.font.medium_bold}
    //     margin-left: 55px;
    // `,
    // "NicknameLabel": styled.p`
    //     ${({ theme }) => theme.font.medium_bold}
    //     white-space: nowrap;
    //     span {
    //         ${({ theme }) => theme.font.medium_bold}
    //         color: ${({ theme }) => theme.color.major}
    //     }
    // `,
}